module.exports = __webpack_public_path__ + "img/zoomout_ov.c15c4761.png";